import { Button } from '@components/common/button';
import AlertWrapper from './AlertWrapper';
import AlertTitle from './AlertTitle';
import AlertContent from './AlertContent';
import { DarkDimmed } from './Dimmed';

export type ConfirmPropsType = {
  title?: React.ReactNode;
  content?: React.ReactNode;
  children?: React.ReactNode;
  submitLabel?: string;
  cancelLabel?: string;
  onClickSubmit?: Function;
  onClickCancel?: Function;
  onClose: Function;
};

export default function Confirm({
  title,
  content,
  children,
  submitLabel,
  cancelLabel,
  onClickSubmit,
  onClickCancel,
  onClose,
}: ConfirmPropsType) {
  const handleClickSubmit = () => {
    onClickSubmit && onClickSubmit();
    onClose();
  };

  const handleClickCancel = () => {
    onClickCancel && onClickCancel();
    onClose();
  };

  return (
    <>
      <AlertWrapper>
        {title && <AlertTitle>{title}</AlertTitle>}
        {content && <AlertContent>{content}</AlertContent>}
        {children}
        <div className="flex items-center justify-between w-full mt-[24px]">
          <div className="flex-1">
            <Button
              fullWidth
              shape="pill"
              size="medium"
              color="tertiary"
              onClick={handleClickCancel}
            >
              {cancelLabel || '취소'}
            </Button>
          </div>
          <div className="ml-[16px] flex-1">
            <Button
              fullWidth
              shape="pill"
              size="medium"
              color="primary"
              onClick={handleClickSubmit}
            >
              {submitLabel || '확인'}
            </Button>
          </div>
        </div>
      </AlertWrapper>
      <DarkDimmed />
    </>
  );
}
